// Mitad "pura" de seo-schema.ts (specs/092-seo-metadata-editor): los helpers
// que las rutas públicas usan en head() para aplicar un override de datos
// estructurados sobre el JSON-LD que ya generan. Viven separados de los
// schemas de zod (que quedan en seo-schema.ts, solo para el editor del panel
// admin) porque estas rutas se cargan en el bundle público — importar zod
// desde acá lo arrastraba al JS inicial de todas las páginas del sitio.

export interface ArticleSchemaData {
  authorName: string;
  authorTitle?: string;
  dateModifiedOverride?: string;
}

export interface ServiceSchemaData {
  additionalDescription?: string;
}

/** Aplica el override de autor/fecha sobre un `BlogPosting` ya generado. */
export function applyArticleOverride(
  base: Record<string, unknown>,
  data: Partial<ArticleSchemaData> | null | undefined,
): Record<string, unknown> {
  if (!data?.authorName) return base;
  return {
    ...base,
    author: {
      "@type": "Person",
      name: data.authorName,
      ...(data.authorTitle ? { jobTitle: data.authorTitle } : {}),
    },
    ...(data.dateModifiedOverride ? { dateModified: data.dateModifiedOverride } : {}),
  };
}

/** Aplica una descripción adicional sobre un `Service` ya generado. */
export function applyServiceOverride(
  base: Record<string, unknown>,
  data: Partial<ServiceSchemaData> | null | undefined,
): Record<string, unknown> {
  if (!data?.additionalDescription) return base;
  const baseDescription = typeof base.description === "string" ? base.description : "";
  return { ...base, description: `${baseDescription} ${data.additionalDescription}`.trim() };
}
